import { getPrincipals } from '../handlers/walletActions/wallet'
import { useWalletProperties } from '../state'

export const setDefaultWalletName = async (principal: string) => {
  const { setWalletName } = useWalletProperties.getState()

  const principals = await getPrincipals().catch(() => [])
  const walletIndex = principals.findIndex((p) => p.toString() === principal.toString())

  setWalletName(principal, `Account ${Math.max(walletIndex, 0) + 1}`)
}
